module.exports = __webpack_public_path__ + "img/04_1_3_1.2033a5db.png";